// extracted by mini-css-extract-plugin
export var fullWidthButton = "_s5-0";